import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import smoothscroll from 'smoothscroll-polyfill';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  bootstrapApplication(AppComponent, appConfig).catch(() => {});
}

// Load polyfill asynchronously to not block bootstrap
setTimeout(() => smoothscroll.polyfill(), 0);

// Optimize bootstrap timing for better LCP
if (document.readyState === 'complete') {
  // Use setTimeout to allow critical CSS to be processed first
  setTimeout(bootstrap, 0);
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
